import { DateTime } from 'luxon';
import { handleActions } from 'redux-actions';

import { resourceStoreTypes, resourceUpserters } from '../core';
import * as actions from './investmentsNewsfeedActions';

const investmentsNewsfeedReducer = handleActions(
  {
    [actions.getInvestmentsNewsfeed]: (state) => state.merge({ isLoading: true }),
    [actions.getInvestmentsNewsfeedSuccess]: (state, { payload }) => {
      const newStore = resourceUpserters.upsertResources(state, payload);
      const symbols = {};
      // sort and keep max 150 news articles.
      const filteredStore = newStore?.resourcesById
        ?.sortBy(
          (article) => DateTime.fromISO(article.publishDate),
          (valueA, valueB) => valueB.toMillis() - valueA.toMillis(),
        )
        // filter articles to only 10 per symbol so one symbol doesn't take up all the redux store (TSLA, usually)
        ?.filter(
          (art) =>
            art?.relatedSymbols?.length === 0 ||
            art?.relatedSymbols?.some((sym) => {
              // sometimes we get relatedSymbols back with undefined related symbols - this filters that out
              if (sym === undefined) {
                return false;
              }
              // initialize symbols key to 1
              if (!(sym && symbols[sym])) {
                symbols[sym] = 1;
                return true;
              }
              // if the article is a part of a 10 + group, filter out the article at the end (bc already sorted)
              if (sym && symbols[sym] && symbols[sym] < 10) {
                symbols[sym] += 1;
                return true;
              }
              return false;
            }),
        );
      return newStore?.merge({ resourcesById: filteredStore?.take(150) });
    },
    [actions.getInvestmentsNewsfeedFailure]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),
  },
  resourceStoreTypes.mkQcsSyncResourceStore(),
);

export const INVESTMENTS_NEWSFEED_REDUCER_KEY = 'investmentsNewsfeedStore';
export default investmentsNewsfeedReducer;
